module.exports = __webpack_public_path__ + "img/plus.033f7d40.svg";